fragment LogNoteForModalFragment on Note {
    id
    body
    audioLog {
        href
        fileId
    }
}
